/**
 * Voice Memos Integration Export
 */

import { Mic } from 'lucide-react';
import { VoiceMemoSidebar } from './voice-memo-sidebar';
import { VoiceMemoManager } from '@/components/features/voice-memo-manager';
import type { Integration } from '@/types/integration';

export const voiceMemosIntegration: Integration = {
  id: 'voice-memos',
  name: 'Voice Memos',
  shortName: 'VM',
  icon: Mic,
  enabled: true,
  configured: true, // No credentials needed
  SidebarView: VoiceMemoSidebar,
  MainView: VoiceMemoManager,
  color: 'blue',
  description: 'Record and manage voice memos with transcription',
};

// Export individual components
export { VoiceMemoSidebar } from './voice-memo-sidebar';
export { VoiceMemoManager } from '@/components/features/voice-memo-manager';

